import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormField } from '@teamfoster/dynamic-forms';

@Component({
  selector: 'app-form-connected-address',
  templateUrl: './form-connected-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormConnectedAddressComponent {
  config!: DynamicFormField;
}
